// import React, { useContext } from "react";
// import "./ProductDisplay.css";
// import star_icon from "../Assets/Assets/star_icon.png";
// import star_dull_icon from "../Assets/Assets/star_dull_icon.png";
// import { ShopContext } from "../../Context/ShopContext";

// // const ProductDisplay = (props) => {
// const ProductDisplay = ({ product }) => {
//   const { addToCart } = useContext(ShopContext);

//   return (
//     <div className="productdisplay">
//       <div className="productdisplay-left">
//         <div className="productdisplay-img-list">
//           <img src={product.image} alt="" />
//           <img src={product.image} alt="" />
//           <img src={product.image} alt="" />
//           <img src={product.image} alt="" />
//         </div>
//         <div className="productdisplay-img">
//           <img className="productdisplay-main-img" src={product.image} />
//         </div>
//       </div>
//       ProductDisplay
//       <div className="productdisplay-right">
//         <h1> {product.name}</h1>
//         <div className="productdisplay-right-stars">
//           <img src={star_icon} alt="" />
//           <img src={star_icon} alt="" />
//           <img src={star_icon} alt="" />
//           <img src={star_icon} alt="" />
//           <img src={star_dull_icon} alt="" />
//           <p>(122)</p>
//         </div>
//         <div className="productdisplay-right-prices">
//           <div className="productdisplay-right-price-old">
//             ${product.old_price}
//           </div>
//           <div className="productdisplay-right-price-new">
//             ${product.new_price}
//           </div>
//         </div>
//         <div className="productdisplay-right-description">
//           A lightweight, usually knitted, pullover shirt, close-fitting and with
//           a round neckline and short sleevless, worn as an undershirt or outer
//           garment.
//         </div>
//         <div className="productdisplay-right-size">
//           <h1> Select Size</h1>
//           <div className="productdisplay-right-sizes">
//             <div>S</div>
//             <div>M</div>
//             <div>L</div>
//             <div>XL</div>
//             <div>XXl</div>
//           </div>
//         </div>
//         <button
//           onClick={() => {
//             addToCart(product.id);
//           }}
//         >
//           ADD TO CART
//         </button>
//         <p className="productdisplay-right-category">
//           <span>Category:</span> Women, T-shirt, Crop Top
//         </p>
//         <p className="productdisplay-right-category">
//           <span>Tags:</span> Modern, Latest
//         </p>
//       </div>
//     </div>
//   );
// };
// export default ProductDisplay;

import React, { useContext } from "react";
import "./ProductDisplay.css";
import star_icon from "../Assets/Assets/star_icon.png";
import star_dull_icon from "../Assets/Assets/star_dull_icon.png";
import { ShopContext } from "../../Context/ShopContext";

const ProductDisplay = ({ product }) => {
  const { addToCart } = useContext(ShopContext);

  // Check if product is defined, render loading or fallback UI otherwise
  if (!product) {
    return <div>Loading product details...</div>;
  }

  return (
    <div className="productdisplay">
      <div className="productdisplay-left">
        <div className="productdisplay-img-list">
          {/* Rendering images safely */}
          <img src={product.image} alt={product.name || "Product image"} />
          <img src={product.image} alt={product.name || "Product image"} />
          <img src={product.image} alt={product.name || "Product image"} />
          <img src={product.image} alt={product.name || "Product image"} />
        </div>
        <div className="productdisplay-img">
          <img
            className="productdisplay-main-img"
            src={product.image}
            alt={product.name || "Product image"}
          />
        </div>
      </div>
      ProductDisplay
      <div className="productdisplay-right">
        <h1>{product.name}</h1>
        <div className="productdisplay-right-stars">
          <img src={star_icon} alt="" />
          <img src={star_icon} alt="" />
          <img src={star_icon} alt="" />
          <img src={star_icon} alt="" />
          <img src={star_dull_icon} alt="" />
          <p>(122)</p>
        </div>
        <div className="productdisplay-right-prices">
          <div className="productdisplay-right-price-old">
            ${product.old_price}
          </div>
          <div className="productdisplay-right-price-new">
            ${product.new_price}
          </div>
        </div>
        <div className="productdisplay-right-description">
          A lightweight, usually knitted, pullover shirt, close-fitting and with
          a round neckline and short sleevless, worn as an undershirt or outer
          garment.
        </div>
        <div className="productdisplay-right-size">
          <h1>Select Size</h1>
          <div className="productdisplay-right-sizes">
            <div>S</div>
            <div>M</div>
            <div>L</div>
            <div>XL</div>
            <div>XXL</div>
          </div>
        </div>
        <button onClick={() => addToCart(product.id)}>ADD TO CART</button>
        <p className="productdisplay-right-category">
          <span>Category:</span> Women, T-shirt, Crop Top
        </p>
        <p className="productdisplay-right-category">
          <span>Tags:</span> Modern, Latest
        </p>
      </div>
    </div>
  );
};

export default ProductDisplay;
